<template>
    <div class="">
        <div class="login-body py-3">
            <div class="d-flex justify-content-center align-items-center" style="height:100vh;">
                <div class="col-lg-4 col-md-6">
                    <div class="card shadow-sm ">
                        <div class="card-body px-lg-5 py-5">
                            <h5 class="font-weight-bold text-center pb-4">Reset Password</h5>
                            <form @submit.prevent="resetPassword()">
                                <div class="form-group mb-2 align-items-center justify-content-center">
                                    <input class="form-control form-control-lg" v-model="$v.form.password.$model" placeholder="New Password" type="password" required autofocus>
                                    <small class="text-danger text-left" v-if="$v.form.password.$dirty && !$v.form.password.minLength">Password must have a minimum of 6 characters.</small>
                                    <small class="text-danger text-left" v-if="$v.form.password.$dirty && !$v.form.password.required">Password is required</small>
                                </div>
                                <div class="form-group mb-4">
                                    <input class="form-control form-control-lg" v-model="$v.form.password_confirmation.$model" placeholder="Confirm Password" type="password" required>
                                    <small class="text-danger text-left" v-if="$v.form.password_confirmation.$dirty && !$v.form.password_confirmation.sameAsPassword">Passwords do not match</small>
                                </div>
                                
                                <div class="">
                                    <div class="m-0 p-0">
                                        <button class="btn btn-custom btn-block btn-lg mb-3" :disabled="disableButton" type="submit">Reset Password</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="d-flex mt-3 justify-content-center">
                        <p class="mr-3 ft-16">
                            <a class="text-muted" href="/">Home</a>
                        </p>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import { required, sameAs, minLength } from 'vuelidate/lib/validators'

export default {
    name: 'NewPassword',
    data() {
        return {
            form: {
                password: '',
                password_confirmation: '',
                token: this.$route.params.reset_token
            }
        }
    },
    validations: {
        form: {
            password: {
                required,
                minLength: minLength(6)
            },
            password_confirmation: {
                required,
                sameAsPassword: sameAs('password')
            }

        }
    },
    computed: {
        disableButton() {

            if (! this.$v.$dirty) {
                return true
            } else if (this.$v.$dirty && this.$v.$anyError) {
                return true
            } else {
                return false
            }
        }
    },
    methods: {
        async resetPassword() {

            try {
                const response = await axios.post('/auth/change-password', { 
                    password: this.form.password,
                    password_confirmation: this.form.password_confirmation,
                    token: this.form.token
                });

                console.log(response)
                if (response.status == 200) {

                    this.form.password = this.form.password_confirmation = '';

                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        title: 'Success',
                        text: 'Password has been reset successfully.'
                    });

                    this.$router.push('/login')
                }
                
            } catch (error) {

            }
        }
    }

}
</script>

<style>
.login-body {
    padding: 0;
    margin: 0;
    background: #F4EEF6;
    /* height: 100vh; */
    /* background: url('../assets/background.png'); */
    /* background-repeat: no-repeat; */
    /* background-size: cover; */
}
.card {
    background-color: #ffffffdb;
}
.ft-16 {
    font-size: 16px;
}

</style>